const fullResponse = (res, statusNumber) =>
  !!(JSON.stringify(res) !== JSON.stringify({}) && res.status === statusNumber)

const emptyResponse = (res, statusNumber) =>
  !!(
    JSON.stringify(res) === JSON.stringify({}) ||
    (res && res.status !== statusNumber)
  )
export { fullResponse, emptyResponse }
